import { buildConfig } from "..";

// This type is generated by the cb-fe-config package and should be copied over until we have a better solution
// https://github.com/jetblueairways/cb-fe-configs

export type Config = {
  APPS: {
    ANDROID: {
      APP_ID: string;
      PLAY_STORE_URL: string;
    };
    IOS: {
      APP_ID: string;
      APP_STORE_URL: string;
    };
  };
  ASAPP?: {
    ASAPP_APP_ID: string;
    ASAPP_AUTO_OPEN_ON_LOAD_URLS: string[];
    ASAPP_CAN_BEGIN_CHAT_URLS: string[];
    ASAPP_HOSTNAME: string;
    SHERPA_AFFILIATE_ID: string;
    SHERPA_APP_ID: string;
  };
  AUTH: {
    CLIENT_ID: string;
    EXCLUDED_ROUTES: string[];
    HANDLE_RETURN_URL: boolean;
    IDLE_TIMER_DURATION: number;
    ISSUER: string;
    IS_ENABLED: boolean;
    IS_PRODUCTION: boolean;
    LOGOUT_WHEN_IDLE: boolean;
    REDIRECT_URI: string;
    WEB_COMPONENT_SRC: string;
  };
  BAG_CALCULATOR: {
    API_URL: string;
    SUBSCRIPTION_KEY: string;
  };
  BRAZE: {
    BRAZE_SRC: string;
    BRAZE_API_KEY: string;
  };
  CB: {
    GATEKEEPER_URL: string;
    LOGGER_URL: string;
    SUBSCRIPTION_KEY: string;
  };
  DY_SECTION_ID: string;
  FEATURE_FLAGS?: {
    DATA_THEME?: string | undefined;
    FLIGHT_SEARCH_FORM: {
      IS_DATE_PICKER_PRICING_ENABLED: boolean;
    };
    IS_HEADER_BG_WHITE_ENABLED?: boolean | undefined;
  };
  FULLSTORY_ORG_ID: string;
  GTM_ID: string;
  MAZE?: {
    MAZE_LOADER_URL: string;
    MAZE_API_KEY: string;
  };
  MGNL: {
    API_NAV: string;
    API_PAGES: string;
    API_TEMPLATES: string;
    DRAFT_TOKEN: string;
    EDIT: string;
    IMAGE_BASE: string;
    LANGUAGES: string[];
    PUBLIC: string;
    SITE_PATH: string;
  };
  PAISLY_JTP: {
    SCRIPT_URL: string;
    TRACKING_SCRIPT_URL: string;
  };
  QUALTRICS: {
    QUALTRICS_IS_ENABLED: boolean;
    QUALTRICS_INTERCEPT_ID: string;
    QUALTRICS_SRC: string;
  };
  TRUST_ARC_URL: string;
};

const { config, clientConfig } = buildConfig<Config>(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- must exist
  process.env.CONFIG_URL!,
);

export { config, clientConfig };
